// extracted by mini-css-extract-plugin
export default {"pageWrap":"lc-z","fullWidth":"mc-z","heading":"nc-z","fullBleed":"oc-z","hidden":"pc-z"};